// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputWithTitleContainer_MKhKK {
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
}

.inputTitle_s_MtK {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  margin-top: 0;
}

.inputContainer_E6Ky7 {
  border-radius: 3px;
  display: flex;
  font-family: "Inter", sans-serif;
  justify-content: space-between;
  align-items: center;
  background: var(--f5-background);
  padding: 8px;
  box-sizing: border-box;

}

.inputWithTitle_EUg6w {
  outline: none;
  border: none;
  font-family: "Inter", sans-serif !important;
  width: 100%;
  background: transparent;
  &::placeholder {
    font-size: 13px;
    font-weight: 300 !important;
  }
}

.inputWithTitle_EUg6w::-webkit-inner-spin-button,
.inputWithTitle_EUg6w::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InputWithTitle/InputWithTitle.module.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;;AAExB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,WAAW;EACX,uBAAuB;EACvB;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n.inputWithTitleContainer {\n  display: flex;\n  flex-direction: column;\n  font-family: \"Inter\", sans-serif;\n}\n\n.inputTitle {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 5px;\n  margin-top: 0;\n}\n\n.inputContainer {\n  border-radius: 3px;\n  display: flex;\n  font-family: \"Inter\", sans-serif;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--f5-background);\n  padding: 8px;\n  box-sizing: border-box;\n\n}\n\n.inputWithTitle {\n  outline: none;\n  border: none;\n  font-family: \"Inter\", sans-serif !important;\n  width: 100%;\n  background: transparent;\n  &::placeholder {\n    font-size: 13px;\n    font-weight: 300 !important;\n  }\n}\n\n.inputWithTitle::-webkit-inner-spin-button,\n.inputWithTitle::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWithTitleContainer": `inputWithTitleContainer_MKhKK`,
	"inputTitle": `inputTitle_s_MtK`,
	"inputContainer": `inputContainer_E6Ky7`,
	"inputWithTitle": `inputWithTitle_EUg6w`
};
export default ___CSS_LOADER_EXPORT___;
